import { TextInput, Button, Form } from "@bfc-software/pallet";
import {
  useTranslation,
  TRANSLATION_NAMESPACE,
} from "@bfc-software/bfc-web-ui/i18n";

import { GoBack } from "../-utilities/login-form-state";

import LoginCard from "./login-card";
import UserName from "./user-name";
import LocationNamePlate from "./location-name-plate";
import styles from "./password-entry.module.css";

interface PasswordEntryProps {
  lang: string;
  email: string;
  setForm: (newValues: { password: string }) => void;
  handleSubmit: (ev: React.FormEvent) => void;
  error?: string;
  goBack: GoBack;
  orgId: string;
  /** Known only once login has returned the org's warehouses. */
  locationName?: string;
}

export default function PasswordEntry({
  setForm,
  handleSubmit,
  lang,
  error,
  goBack,
  email,
  locationName,
}: PasswordEntryProps) {
  const { t } = useTranslation({
    lang: lang,
    namespace: TRANSLATION_NAMESPACE.login,
  });

  return (
    <LoginCard data-testid="password-entry">
      <div className={styles.identity}>
        {locationName && (
          <LocationNamePlate variant="header" name={locationName} />
        )}
        <UserName>{email}</UserName>
      </div>
      <Form
        display={{ align: "center" }}
        onSubmit={handleSubmit}
        button={
          <Button
            kind="text-only"
            variant="primary"
            id="password-submit"
            text={t("passwordEntryButton")}
            isDisabled={false}
            type="submit"
          />
        }
      >
        <TextInput
          id="password-input"
          className={styles.passwordInput}
          type="password"
          label={t("password")}
          name="password"
          onChange={(ev) => setForm({ password: ev.target.value })}
          autocomplete="current-password"
          isRequired={true}
          errorMessage={error}
        />
      </Form>
      <Button
        kind="text-icon-left"
        icon="ArrowLeft"
        onPress={goBack.handler}
        variant="tertiary"
        text={goBack.label}
        type="submit"
      />
    </LoginCard>
  );
}
